import React, { memo, useContext } from 'react';
import T from '@prisjakt/ui-translate';
import Breadcrumb from '@prisjakt/ui-breadcrumb';
import { bemGenerator } from '@prisjakt/ui-base';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { AppContext } from '@prisjakt/ui-app-context';
import EmailSent from '../components/email-sent';
import './index.scss';

const styles = bemGenerator('forgot-password', ['link']);

const RecoverLinkSentPage = ({ email, backTo }) => {
  const { t, market } = useContext(AppContext);
  return [
    <EmailSent
      key="forgot-password-email-sent"
      email={email}
      market={market}
      backTo={backTo}
      title={t('account', 'forgot-password.email-sent-title')}
      information={t('account', 'forgot-password.email-sent-information')}
      checkEmailNotice={<T domain="account">forgot-password.email-notice.md</T>}
      breadcrumbComponent={
        <Breadcrumb
          homeText={t('common', 'breadcrumb.home')}
          path={[
            {
              pathName: 'forgot-password',
              name: t('account', 'forgot-password.email-sent-title'),
              id: '0',
            },
          ]}
        />
      }
    />,
    <div key="forgot-password-email-sent-back-link" className="row">
      <div className="columns small-12">
        <p>
          {t('account', 'back-to-login.text', {
            login: (
              <Link className={styles.link} to="/login">
                {t('account', 'back-to-login.link')}
              </Link>
            ),
          })}
        </p>
      </div>
    </div>,
  ];
};

const { string, shape } = PropTypes;

RecoverLinkSentPage.propTypes = {
  email: string.isRequired,
  backTo: shape({
    url: string,
    name: string,
  }),
};

RecoverLinkSentPage.defaultProps = {
  backTo: undefined,
};

export default memo(RecoverLinkSentPage);
